import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import User360 from './User360';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'User 360 | Admin',
    component: (
      <AdminLayout>
        <User360 />
      </AdminLayout>
    ),
  };
}

export default action;
